import React from "react";

const EscortForm = ({ formData, setFormData, errors, readOnly = false }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCnicChange = (e) => {
    const { name, value } = e.target;
    // Format CNIC: XXXXX-XXXXXXX-X
    const digits = value.replace(/\D/g, "").slice(0, 13);
    let formatted = digits;
    if (digits.length > 5 && digits.length <= 12) {
      formatted = `${digits.slice(0, 5)}-${digits.slice(5)}`;
    } else if (digits.length > 12) {
      formatted = `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`;
    }
    setFormData((prev) => ({ ...prev, [name]: formatted }));
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    // Format Phone: XXXX-XXXXXXX
    const digits = value.replace(/\D/g, "").slice(0, 11);
    let formatted = digits;
    if (digits.length > 4) {
      formatted = `${digits.slice(0, 4)}-${digits.slice(4)}`;
    }
    setFormData((prev) => ({ ...prev, [name]: formatted }));
  };

  return (
    <div className="content p-4">
      <div className="accordion" id="escortFormAccordion">
        
        {/* SECTION 1: Patient Details */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingPatient">
            <button
              className="accordion-button bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsePatient"
              aria-expanded="true"
              aria-controls="collapsePatient"
            >
              1. Patient Details
            </button>
          </h2>
          <div
            id="collapsePatient"
            className="accordion-collapse collapse show"
            aria-labelledby="headingPatient"
            data-bs-parent="#escortFormAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.patient_name ? "is-invalid" : ""}`}
                      name="patient_name"
                      value={formData.patient_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Patient Name"
                    />
                    <label>Patient Name</label>
                    {errors?.patient_name && <div className="invalid-feedback">{errors.patient_name}</div>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.cnic_bform ? "is-invalid" : ""}`}
                      name="cnic_bform"
                      value={formData.cnic_bform || ""}
                      onChange={handleCnicChange}
                      disabled={readOnly}
                      placeholder="CNIC / B-Form No."
                    />
                    <label>CNIC / B-Form No.</label>
                    {errors?.cnic_bform && <div className="invalid-feedback">{errors.cnic_bform}</div>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.age_gender ? "is-invalid" : ""}`}
                      name="age_gender"
                      value={formData.age_gender || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Age / Gender (e.g. 28 / Male)"
                    />
                    <label>Age / Gender</label>
                    {errors?.age_gender && <div className="invalid-feedback">{errors.age_gender}</div>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="date"
                      className={`form-control ${errors?.date_of_admission_request ? "is-invalid" : ""}`}
                      name="date_of_admission_request"
                      value={formData.date_of_admission_request || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                    />
                    <label>Date of Admission Request</label>
                    {errors?.date_of_admission_request && (
                      <div className="invalid-feedback">{errors.date_of_admission_request}</div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className={`form-control ${errors?.residential_address ? "is-invalid" : ""}`}
                      name="residential_address"
                      value={formData.residential_address || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Residential Address"
                      style={{ height: "80px" }}
                    />
                    <label>Residential Address</label>
                    {errors?.residential_address && <div className="invalid-feedback">{errors.residential_address}</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 2: Applicant / Nearest Relative / Legal Guardian Details */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingApplicant">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseApplicant"
              aria-expanded="false"
              aria-controls="collapseApplicant"
            >
              2. Applicant / Nearest Relative / Legal Guardian Details
            </button>
          </h2>
          <div
            id="collapseApplicant"
            className="accordion-collapse collapse"
            aria-labelledby="headingApplicant"
            data-bs-parent="#escortFormAccordion"
          >
            <div className="accordion-body pt-4">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.applicant_name ? "is-invalid" : ""}`}
                      name="applicant_name"
                      value={formData.applicant_name || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Name"
                    />
                    <label>Name</label>
                    {errors?.applicant_name && <div className="invalid-feedback">{errors.applicant_name}</div>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.applicant_cnic ? "is-invalid" : ""}`}
                      name="applicant_cnic"
                      value={formData.applicant_cnic || ""}
                      onChange={handleCnicChange}
                      disabled={readOnly}
                      placeholder="CNIC No."
                    />
                    <label>CNIC No.</label>
                    {errors?.applicant_cnic && <div className="invalid-feedback">{errors.applicant_cnic}</div>}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.applicant_relationship ? "is-invalid" : ""}`}
                      name="applicant_relationship"
                      value={formData.applicant_relationship || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Relationship to Patient"
                    />
                    <label>Relationship to Patient</label>
                    {errors?.applicant_relationship && (
                      <div className="invalid-feedback">{errors.applicant_relationship}</div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating form-floating-outline">
                    <input
                      type="text"
                      className={`form-control ${errors?.applicant_contact ? "is-invalid" : ""}`}
                      name="applicant_contact"
                      value={formData.applicant_contact || ""}
                      onChange={handlePhoneChange}
                      disabled={readOnly}
                      placeholder="Contact Number"
                    />
                    <label>Contact Number</label>
                    {errors?.applicant_contact && <div className="invalid-feedback">{errors.applicant_contact}</div>}
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-floating form-floating-outline">
                    <textarea
                      className={`form-control ${errors?.applicant_address ? "is-invalid" : ""}`}
                      name="applicant_address"
                      value={formData.applicant_address || ""}
                      onChange={handleChange}
                      disabled={readOnly}
                      placeholder="Address"
                      style={{ height: "80px" }}
                    />
                    <label>Address</label>
                    {errors?.applicant_address && <div className="invalid-feedback">{errors.applicant_address}</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 3: Grounds for Involuntary Admission Request */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingGrounds">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseGrounds"
              aria-expanded="false"
              aria-controls="collapseGrounds"
            >
              3. Grounds for Involuntary Admission Request
            </button>
          </h2>
          <div
            id="collapseGrounds"
            className="accordion-collapse collapse"
            aria-labelledby="headingGrounds"
            data-bs-parent="#escortFormAccordion"
          >
            <div className="accordion-body pt-4">
              <p className="text-muted fw-semibold">I state that the above-named patient:</p>
              
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="ground_mental_disorder"
                  name="ground_mental_disorder"
                  checked={!!formData.ground_mental_disorder}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark" htmlFor="ground_mental_disorder">
                  Is suffering from a suspected or diagnosed mental disorder
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="ground_harm_self"
                  name="ground_harm_self"
                  checked={!!formData.ground_harm_self}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark" htmlFor="ground_harm_self">
                  Poses a risk of harm to self
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="ground_harm_others"
                  name="ground_harm_others"
                  checked={!!formData.ground_harm_others}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark" htmlFor="ground_harm_others">
                  Poses a risk of harm to others
                </label>
              </div>

              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="ground_unable_care_self"
                  name="ground_unable_care_self"
                  checked={!!formData.ground_unable_care_self}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark" htmlFor="ground_unable_care_self">
                  Is unable to care for self due to mental illness
                </label>
              </div>

              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="ground_refuses_voluntary"
                  name="ground_refuses_voluntary"
                  checked={!!formData.ground_refuses_voluntary}
                  onChange={handleChange}
                  disabled={readOnly}
                />
                <label className="form-check-label text-dark" htmlFor="ground_refuses_voluntary">
                  Refuses voluntary assessment or admission
                </label>
              </div>

              <div className="alert alert-warning mb-0 border-0" role="alert">
                <h6 className="alert-heading fw-bold mb-1">Legal Pre-requisite Notice (Sindh Mental Health Act 2013):</h6>
                <ul className="mb-0 small" style={{ paddingLeft: "1.2rem" }}>
                  <li>A qualified psychiatrist determines that the patient is suffering from a mental disorder; AND</li>
                  <li>Admission is necessary for the patient’s health or safety, or for the protection of others; AND</li>
                  <li>The patient is unwilling or lacks capacity to consent.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 4: Signatures & Declarations */}
        <div className="accordion-item card mb-3">
          <h2 className="accordion-header" id="headingSignatures">
            <button
              className="accordion-button collapsed bg-label-primary text-primary fw-bold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSignatures"
              aria-expanded="false"
              aria-controls="collapseSignatures"
            >
              4. Signatures & Certifications
            </button>
          </h2>
          <div
            id="collapseSignatures"
            className="accordion-collapse collapse"
            aria-labelledby="headingSignatures"
            data-bs-parent="#escortFormAccordion"
          >
            <div className="accordion-body pt-4">
              
              {/* Applicant Signature */}
              <div className="border rounded p-3 mb-4">
                <h5 className="fw-bold mb-3 text-secondary">Applicant / Nearest Relative / Legal Guardian</h5>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.signature_applicant_name ? "is-invalid" : ""}`}
                        name="signature_applicant_name"
                        value={formData.signature_applicant_name || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Applicant Name"
                      />
                      <label>Applicant Name / Signature</label>
                      {errors?.signature_applicant_name && (
                        <div className="invalid-feedback">{errors.signature_applicant_name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        className={`form-control ${errors?.signature_applicant_date ? "is-invalid" : ""}`}
                        name="signature_applicant_date"
                        value={formData.signature_applicant_date || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                      />
                      <label>Date</label>
                      {errors?.signature_applicant_date && (
                        <div className="invalid-feedback">{errors.signature_applicant_date}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Assessing Psychiatrist Certification */}
              <div className="border rounded p-3 mb-4">
                <h5 className="fw-bold mb-3 text-secondary">Assessing Psychiatrist</h5>
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.psychiatrist_name ? "is-invalid" : ""}`}
                        name="psychiatrist_name"
                        value={formData.psychiatrist_name || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Psychiatrist Name"
                      />
                      <label>Name</label>
                      {errors?.psychiatrist_name && <div className="invalid-feedback">{errors.psychiatrist_name}</div>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.psychiatrist_pmdc ? "is-invalid" : ""}`}
                        name="psychiatrist_pmdc"
                        value={formData.psychiatrist_pmdc || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="PMDC Registration No."
                      />
                      <label>PMDC Registration No.</label>
                      {errors?.psychiatrist_pmdc && <div className="invalid-feedback">{errors.psychiatrist_pmdc}</div>}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="datetime-local"
                        className={`form-control ${errors?.psychiatrist_certified_at ? "is-invalid" : ""}`}
                        name="psychiatrist_certified_at"
                        value={
                          formData.psychiatrist_certified_at
                            ? formData.psychiatrist_certified_at.replace(" ", "T").substring(0, 16)
                            : ""
                        }
                        onChange={handleChange}
                        disabled={readOnly}
                      />
                      <label>Date & Time of Certification</label>
                      {errors?.psychiatrist_certified_at && (
                        <div className="invalid-feedback">{errors.psychiatrist_certified_at}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* TRH Authorized Representative */}
              <div className="border rounded p-3 mb-4">
                <h5 className="fw-bold mb-3 text-secondary">TRH Authorized Representative</h5>
                <div className="row g-3">
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.trh_representative_name ? "is-invalid" : ""}`}
                        name="trh_representative_name"
                        value={formData.trh_representative_name || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Name"
                      />
                      <label>Representative Name</label>
                      {errors?.trh_representative_name && (
                        <div className="invalid-feedback">{errors.trh_representative_name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.trh_representative_designation ? "is-invalid" : ""}`}
                        name="trh_representative_designation"
                        value={formData.trh_representative_designation || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Designation"
                      />
                      <label>Designation</label>
                      {errors?.trh_representative_designation && (
                        <div className="invalid-feedback">{errors.trh_representative_designation}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        className={`form-control ${errors?.trh_representative_date ? "is-invalid" : ""}`}
                        name="trh_representative_date"
                        value={formData.trh_representative_date || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                      />
                      <label>Date</label>
                      {errors?.trh_representative_date && (
                        <div className="invalid-feedback">{errors.trh_representative_date}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Witnesses */}
              <div className="border rounded p-3">
                <h5 className="fw-bold mb-3 text-secondary">Witnesses (Two Required)</h5>
                <div className="row g-3">
                  <div className="col-md-6 border-end pe-md-4">
                    <h6 className="fw-semibold mb-2">Witness 1</h6>
                    <div className="form-floating form-floating-outline mb-3">
                      <input
                        type="text"
                        className={`form-control ${errors?.witness1_name ? "is-invalid" : ""}`}
                        name="witness1_name"
                        value={formData.witness1_name || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Witness 1 Name"
                      />
                      <label>Name</label>
                      {errors?.witness1_name && <div className="invalid-feedback">{errors.witness1_name}</div>}
                    </div>
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.witness1_signature ? "is-invalid" : ""}`}
                        name="witness1_signature"
                        value={formData.witness1_signature || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Witness 1 Signature"
                      />
                      <label>Signature/Declaration</label>
                      {errors?.witness1_signature && <div className="invalid-feedback">{errors.witness1_signature}</div>}
                    </div>
                  </div>

                  <div className="col-md-6 ps-md-4">
                    <h6 className="fw-semibold mb-2">Witness 2</h6>
                    <div className="form-floating form-floating-outline mb-3">
                      <input
                        type="text"
                        className={`form-control ${errors?.witness2_name ? "is-invalid" : ""}`}
                        name="witness2_name"
                        value={formData.witness2_name || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Witness 2 Name"
                      />
                      <label>Name</label>
                      {errors?.witness2_name && <div className="invalid-feedback">{errors.witness2_name}</div>}
                    </div>
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className={`form-control ${errors?.witness2_signature ? "is-invalid" : ""}`}
                        name="witness2_signature"
                        value={formData.witness2_signature || ""}
                        onChange={handleChange}
                        disabled={readOnly}
                        placeholder="Witness 2 Signature"
                      />
                      <label>Signature/Declaration</label>
                      {errors?.witness2_signature && <div className="invalid-feedback">{errors.witness2_signature}</div>}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default EscortForm;
